import { Link } from 'react-router'
import { LuArrowRight } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { SitePhoto } from '@/components/ui/SitePhoto'
import { primaryLink } from '@/components/ui/linkStyles'
import { kandakePortrait, kandakeOutdoors, herbalWalkPortrait } from '@/assets/siteMedia'

export const ProductsHowToOrder = () => (
  <section className="border-t border-base-200 bg-white py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <div>
          <SectionHeader title="Personalised to you," accent="not off the shelf" className="mb-6" />
          <Reveal>
            <div className="space-y-4 text-base leading-7 text-base-600">
              <p>
                Every product is dispensed based on your individual health picture. Kandake will
                advise on the correct formulation, dosage, and combination of remedies that suits
                your specific needs, ensuring you get the most from your herbal protocol.
              </p>
              <p>
                Get in touch to enquire about any product. Online ordering will be available
                shortly.
              </p>
            </div>
            <Link to={`${ROUTES.CONTACT}?service=product`} className={`${primaryLink} mt-8`}>
              Get in Touch
              <LuArrowRight aria-hidden="true" className="h-4 w-4 shrink-0" />
            </Link>
          </Reveal>
        </div>

        <Reveal>
          <div className="grid grid-cols-2 gap-4">
            <SitePhoto
              src={kandakePortrait}
              alt="Kandake in her herbal practice"
              aspect="aspect-[3/4]"
            />
            <div className="mt-8 flex flex-col gap-4">
              <SitePhoto src={kandakeOutdoors} alt="Kandake selecting fresh herbs" />
              <SitePhoto src={herbalWalkPortrait} alt="Plant knowledge in practice" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
)
